import styled from 'styled-components';

export const P = styled.p`
   font-size: ${({theme}) => theme.font.S};
    opacity: 1;
    color: ${({theme}) => theme.secondColor};
     font-weight: 500;
     margin-bottom: 0px;
`;
